import { render, staticRenderFns } from "./TSCardDeckRegions.vue?vue&type=template&id=0452e3f4&scoped=true&"
import script from "./TSCardDeckRegions.vue?vue&type=script&lang=js&"
export * from "./TSCardDeckRegions.vue?vue&type=script&lang=js&"
import style0 from "./TSCardDeckRegions.vue?vue&type=style&index=0&id=0452e3f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452e3f4",
  null
  
)

export default component.exports